// Must stay the first import: it has to run before any dependency beneath ./app/App loads.
import './shared/lib/globalPolyfill'

// Self-hosted IBM Plex for the CRM theme (~/shared/lib/theme); bundled so
// text never waits on a font download.
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-sans/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import './index.css'

import { createRoot } from 'react-dom/client'
import App from './app/App'
import { syncFaviconWithColorScheme } from './shared/lib/faviconTheme'

syncFaviconWithColorScheme()

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found')
createRoot(container).render(<App />)
